import { styled } from 'styled-components';

export const StyledSum = styled.div<{ $isFirst?: boolean }>`
    text-align: ${({ $isFirst }) => ($isFirst ? 'left' : 'right')};
    padding-right: 0.5em;
`;
